import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="widget-form"
export default class extends Controller {
  connect() {
    this.boundSubmit = async (event) => {
      event.preventDefault();
      console.log("hello from widget form");
      // const response = Turbo.navigator.submitForm(this.element);
      let action = this.element.action;
      let data = new FormData(this.element);

      console.log("action", action, "data", data);

      const response = await fetch(action, {
        method: "post",
        body: data,
      });

      window.top.postMessage({ redirect_url: response.url }, "*");
    };
    this.element.addEventListener("submit", this.boundSubmit);
  }

  disconnect() {
    this.element.removeEventListener("submit", this.boundSubmit);
  }
}
